import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';
import { AccountSharedModule } from 'apps/account/src/account-shared';
import { AccountManagementModule } from '../../modules/account-management/account-management.module';
import { InstantSearchModule } from '../../modules/instant-search/instant-search.module';
import { CheckCompanyTypeDirective } from './directives/check-company-type.directive';
import { CheckSpaceTypeDirective } from './directives/check-space-type.directive';
import { SpacesHistory } from './spaces-history.service';
import { SpacesComponent } from './spaces.component';
import { SpacesService } from './spaces.service';

@NgModule({
    declarations: [
        SpacesComponent,
        CheckSpaceTypeDirective,
        CheckCompanyTypeDirective
    ],
    imports: [
        MatIconModule,
        CommonModule,
        FormsModule,
        AccountSharedModule,
        InstantSearchModule,
        UIRouterUpgradeModule.forChild({}),
        AccountManagementModule
    ],
    exports: [
        SpacesComponent,
        CheckSpaceTypeDirective,
        CheckCompanyTypeDirective
    ],
    providers: [
        SpacesService,
        SpacesHistory
    ]
})
export class SpacesModule {
}
